// @flow

import { type Amount, type CurrencyCode } from '../types';

export function getCurrencyCode(amount: Amount): CurrencyCode {
  return amount[0];
}
